export default "__VITE_ASSET__BRdasQd4__"